export default "__VITE_ASSET__DvlHamiG__"